/* eslint-disable */
import { GetterTree } from "vuex";
import { Staff } from "@/models/staff";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { StaffState } from "@/types/staff";

const getters: GetterTree<StaffState, RootState> = {
  list: (state) => {
    return state.pagination ? state.pagination.data : [];
  },
  pagination: (state) => {
    return state.pagination || new Pagination();
  },
  single: (state) => {
    return state.single || new Staff();
  },
  selectItem: (state) => {
    return state.pagination
      ? state.pagination.data.map((staff) => Staff.toSelectItem(staff))
      : [];
  },
  find: (state) => (id: number) => {
    return state.pagination
      ? state.pagination.data.find((staff) => {
          return staff.id == id;
        })
      : new Staff();
  },
};

export default getters;
